
import React from 'react';
import { MatchDetailsList } from '../match-details/MatchDetailsList';

interface FilteredMatchesListProps {
  matches: any[];
  selectedStat: string | null;
}

export const FilteredMatchesList: React.FC<FilteredMatchesListProps> = ({ 
  matches,
  selectedStat
}) => {
  return (
    <div className="mt-4">
      <MatchDetailsList 
        matches={matches}
        selectedStat={selectedStat}
      />
    </div>
  );
};
